import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";

interface CountdownTimerProps {
  timeLeft: number;
  totalTime: number;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ timeLeft, totalTime = 600 }) => {
  const progress = Math.max(0, Math.min(100, (timeLeft / totalTime) * 100));

  // Determine the color based on remaining time
  const getTimerColor = (): string => {
    if (timeLeft > 120) return "green"; // More than 2 minutes left
    if (timeLeft > 30) return "orange"; // Between 2 minutes and 30 seconds
    return "red"; // Less than 30 seconds left
  };

  // Format time as MM:SS
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  return (
    <Box
      sx={{
        backgroundColor: "#f8f9fa",
        p: 2,
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
        mb: 3,
      }}
    >
      <Typography variant="h6" fontWeight="bold" mb={1}>
        Time Left to Complete Checkout
      </Typography>
      <Typography
        variant="h4"
        fontWeight="bold"
        color={getTimerColor()}
        sx={{ mb: 1 }}
      >
        {formatTime(timeLeft)}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 10,
          borderRadius: 5,
          backgroundColor: "#e0e0e0",
          "& .MuiLinearProgress-bar": {
            backgroundColor: getTimerColor(),
          },
        }}
      />
      {timeLeft <= 120 && (
        <Typography variant="body2" color="error" mt={1}>
          {timeLeft > 30
            ? "Hurry! Only 2 minutes left to complete your purchase."
            : "Hurry! Only 30 seconds left to complete your purchase."}
        </Typography>
      )}
    </Box>
  );
};

export default CountdownTimer;